import React, { Component } from 'react';
import {
    Row,
    Card,
    CardBody,
    Button,
    FormGroup,
    Label,
    Input,
    Container,
    Col,
    Alert
} from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import { END_POINT } from '../../constants/defaultValues';
import axios from 'axios';
import moment from 'moment';

class BookingOnline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer_name: '',
            customer_phone: '',
            customer_email: '',
            booking_date: moment().format('YYYY-MM-DD'),
            booking_time: moment().add(1, 'hours').format('HH:mm'), // Default next hour
            party_size: 2,
            special_requests: '',
            loading: false,
            success: false,
            error: null,
            storeName: '',
            banks: []
        };
    }

    async componentDidMount() {
        // Có thể gọi API lấy info cửa hàng để hiển thị tên, logo...
        const store = this.props.match.params.store;
        this.setState({ storeName: store, loadingInfo: true });

        // Fetch banks list
        try {
            const bankRes = await axios.get('https://api.vietqr.io/v2/banks');
            if (bankRes.data && bankRes.data.data) {
                this.setState({ banks: bankRes.data.data });
            }
        } catch (e) {
            console.error('Error fetching banks', e);
        }

        try {
            // Fetch public store info (settings, payment)
            // Note: pass store in query for testing/completeness
            const res = await axios.get(`${END_POINT}/booking/public/info?store=${store}`);
            if (res.data.status === 200) {
                const { booking_enabled, setting, payment, store: storeInfo } = res.data.data;
                this.setState({
                    loadingInfo: false,
                    bookingEnabled: booking_enabled,
                    storeSettings: setting,
                    paymentInfo: payment,
                    storeInfo: storeInfo,
                    storeName: storeInfo.companyName || store
                });
            } else {
                 this.setState({ loadingInfo: false, bookingEnabled: false });
            }
        } catch (error) {
            console.error('Error fetching store info:', error);
            this.setState({ loadingInfo: false, bookingEnabled: false });
        }
    }

    getBankName = (code) => {
        const { banks } = this.state;
        if (!code) return '';
        const codeStr = code.toString();
        const found = banks.find(b => b.bin === codeStr || b.code === codeStr || b.shortName === codeStr);
        return found ? `${found.shortName} - ${found.name}` : code;
    };

    handleChange = (event) => {
        const { target } = event;
        const value = target.value;
        const name = target.name;
        this.setState({ [name]: value });
    };

    handleSubmit = async () => {
        const {
            customer_name,
            customer_phone,
            booking_date,
            booking_time,
            party_size,
            special_requests,
            customer_email
        } = this.state;
        const store = this.props.match.params.store;

        if (!customer_name || !customer_phone || !booking_date || !booking_time || !party_size) {
            this.setState({ error: 'Vui lòng điền đầy đủ thông tin bắt buộc (*)' });
            return;
        }

        this.setState({ loading: true, error: null, success: false });

        try {
            // Lưu ý: Endpoint này không cần Auth header
            // Ở development mode, ta cần truyền store qua body hoặc query nếu backend không resolve được subdomain localhost
            // Nhưng backend hiện tại split hostname. Để test local ta có thể hardcode hoặc backend phải support param 'store'
            // Check lại service: CreatePublic lấy store từ params passed into it. 
            // Route: router.post('/public', ... const store = req.hostname ... )
            // Vấn đề: req.hostname ở local là localhost.
            // Giải pháp: Gửi store trong body và sửa backend ưu tiên body.store nếu có (cho testing).
            
            // Tuy nhiên tôi không sửa backend ngay để tránh conflict.
            // Giả sử user test trên environment đúng hoặc tôi sẽ sửa backend chút xíu để support testing.
            
            // Nhưng khoan, ở message trước, route code là:
            // const store = req.hostname.split('.')[0];
            // const result = await BookingService.CreatePublic({ store, body: req.body });
            
            // Nếu tôi gọi từ Client, tôi không thể sửa req.hostname được.
            // Nên tôi sẽ gửi thêm store trong body, và hy vọng backend có thể update để đọc nó.
            
            const payload = {
                customer_name,
                customer_phone,
                customer_email,
                booking_date,
                booking_time,
                party_size,
                special_requests,
                store: store
            };

            // Hack: Sửa backend để đọc store từ body nếu hostname là localhost
            // Tạm thời cứ request, nếu fail sẽ sửa backend.
            
            const res = await axios.post(`${END_POINT}/booking/public`, payload);

            if (res.data.status === 200) {
                this.setState({ 
                    success: true, 
                    loading: false,
                    message: res.data.responseText,
                    bookingSuccessData: res.data.data // Store booking data for QR code
                });
            } else {
                this.setState({ 
                    error: res.data.responseText || 'Lỗi đặt bàn', 
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Booking error:', error);
            this.setState({ 
                error: error.response?.data?.responseText || 'Có lỗi xảy ra khi kết nối server', 
                loading: false 
            });
        }
    };

    render() {
        const { 
            customer_name, customer_phone, customer_email, 
            booking_date, booking_time, party_size, special_requests,
            loading, success, error, message, storeName
        } = this.state;

        if (success) {
            const { storeSettings, paymentInfo, bookingSuccessData } = this.state;
            const depositRequired = storeSettings && storeSettings.deposit_required;

            return (
                <div style={styles.container}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col md="8" lg="6">
                                <Card className="shadow-lg">
                                    <CardBody className="text-center p-5">
                                        <div className="mb-4">
                                            <i className="simple-icon-check text-success" style={{ fontSize: '4rem' }} />
                                        </div>
                                        <h2 className="mb-3">Đặt bàn thành công!</h2>
                                        <p className="text-muted mb-4">{message}</p>
                                        
                                        {depositRequired && paymentInfo && (
                                            <div className="mt-4 p-3 border rounded bg-light">
                                                <h5 className="text-danger font-weight-bold mb-3">Yêu cầu Đặt cọc</h5>
                                                <p>Vui lòng chuyển khoản đặt cọc để giữ chỗ:</p>
                                                <h3 className="text-primary font-weight-bold">
                                                    {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(storeSettings.deposit_amount)}
                                                </h3>
                                                
                                                <div className="my-3">
                                                    <img 
                                                        src={`https://img.vietqr.io/image/${paymentInfo.bankName}-${paymentInfo.accountNumber}-compact2.png?amount=${storeSettings.deposit_amount}&addInfo=DAT COC BOOKING ${bookingSuccessData ? bookingSuccessData.id : ''}&accountName=${paymentInfo.accountName}`}
                                                        alt="QR Code Pay"
                                                        style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                                                    />
                                                </div>
                                                
                                                <div className="text-left d-inline-block mt-2">
                                                    <p className="mb-1"><strong>Ngân hàng:</strong> {this.getBankName(paymentInfo.bankName)}</p>
                                                    <p className="mb-1"><strong>Số tài khoản:</strong> {paymentInfo.accountNumber}</p>
                                                    <p className="mb-1"><strong>Chủ tài khoản:</strong> {paymentInfo.accountName}</p>
                                                    <p className="mb-1"><strong>Nội dung:</strong> DAT COC BOOKING {bookingSuccessData ? bookingSuccessData.id : ''}</p>
                                                </div>
                                            </div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        }

        if (this.state.bookingEnabled === false) {
             return (
                <div style={styles.container}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col md="10" lg="8">
                                <div className="text-center mb-5">
                                    <h1 className="text-white display-4">{storeName || 'Cửa hàng'}</h1>
                                </div>
                                <Card className="shadow-lg border-0 p-5 text-center">
                                     <h3 className="text-muted">Cửa hàng tạm ngưng nhận đặt bàn online.</h3>
                                     <p>Vui lòng liên hệ hotline để được hỗ trợ.</p>
                                </Card>
                             </Col>
                        </Row>
                    </Container>
                </div>
             );
        }

        return (
            <div style={styles.container}>
                <Container>
                    <Row className="justify-content-center">
                        <Col md="10" lg="8">
                            <div className="text-center mb-5">
                                <h1 className="text-white display-4">Đặt bàn tại {storeName || 'Cửa hàng'}</h1>
                                <p className="lead text-white-50">Vui lòng điền thông tin để giữ chỗ</p>
                            </div>
                            
                            <Card className="shadow-lg border-0" style={{ borderRadius: '1rem' }}>
                                <CardBody className="p-5">
                                    {error && <Alert color="danger">{error}</Alert>}
                                    
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label className="font-weight-bold">Họ và tên <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="text"
                                                    name="customer_name"
                                                    value={customer_name}
                                                    onChange={this.handleChange}
                                                    placeholder="Ví dụ: Nguyễn Văn A"
                                                    bsSize="lg"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label className="font-weight-bold">Số điện thoại <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="tel"
                                                    name="customer_phone"
                                                    value={customer_phone}
                                                    onChange={this.handleChange}
                                                    placeholder="09xx xxx xxx"
                                                    bsSize="lg"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="12">
                                            <FormGroup>
                                                <Label className="font-weight-bold">Email</Label>
                                                <Input
                                                    type="email"
                                                    name="customer_email"
                                                    value={customer_email}
                                                    onChange={this.handleChange}
                                                    placeholder="email@example.com (để nhận xác nhận)"
                                                    bsSize="lg"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <Label className="font-weight-bold">Ngày <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="date"
                                                    name="booking_date"
                                                    value={booking_date}
                                                    onChange={this.handleChange}
                                                    bsSize="lg"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <Label className="font-weight-bold">Giờ <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="time"
                                                    name="booking_time"
                                                    value={booking_time}
                                                    onChange={this.handleChange}
                                                    bsSize="lg"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <Label className="font-weight-bold">Số khách <span className="text-danger">*</span></Label>
                                                <Input
                                                    type="number"
                                                    name="party_size"
                                                    value={party_size}
                                                    onChange={this.handleChange}
                                                    min="1"
                                                    bsSize="lg"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <FormGroup>
                                        <Label className="font-weight-bold">Ghi chú thêm</Label>
                                        <Input
                                            type="textarea"
                                            name="special_requests"
                                            value={special_requests}
                                            onChange={this.handleChange}
                                            rows="3"
                                            placeholder="Yêu cầu đặc biệt (ghế trẻ em, dị ứng, v.v.)"
                                        />
                                    </FormGroup>

                                    <div className="text-center mt-4">
                                        <Button 
                                            color="primary" 
                                            size="lg" 
                                            className="px-5 py-3 font-weight-bold" 
                                            style={{ borderRadius: '2rem', minWidth: '200px' }}
                                            onClick={this.handleSubmit}
                                            disabled={loading}
                                        >
                                            {loading ? 'Đang xử lý...' : 'XÁC NHẬN ĐẶT BÀN'}
                                        </Button>
                                    </div>

                                </CardBody>
                            </Card>
                            
                            <div className="text-center mt-4 text-white-50">
                                <small>&copy; Powered by VMASS POS</small>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const styles = {
    container: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #141E30 0%, #243B55 100%)',
        paddingTop: '80px',
        paddingBottom: '40px'
    }
};

export default BookingOnline;
